(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitto-product-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vitto-product]').forEach((root) => {
    const mainImage = root.querySelector('.vitto-product__main-image');
    root.querySelectorAll('[data-vitto-image]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.vittoImage;
        mainImage.alt = button.dataset.vittoAlt;
        root.querySelectorAll('[data-vitto-image]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });
    const variantId = root.querySelector('[data-vitto-variant-id]');
    const checkedVariant = root.querySelector('input[name="vitto-variant"]:checked');
    if (variantId && checkedVariant) variantId.value = checkedVariant.value;
    root.querySelectorAll('input[name="vitto-variant"]').forEach((input) => {
      input.addEventListener('change', () => { variantId.value = input.value; });
    });
    const quantity = root.querySelector('[data-vitto-quantity]');
    const checkedOffer = root.querySelector('input[name="vitto-offer"]:checked');
    if (quantity && checkedOffer) quantity.value = checkedOffer.value;
    root.querySelectorAll('input[name="vitto-offer"]').forEach((input) => {
      input.addEventListener('change', () => {
        quantity.value = input.value;
        root.querySelectorAll('.vitto-product__offer').forEach((offer) => offer.classList.remove('is-selected'));
        input.closest('.vitto-product__offer').classList.add('is-selected');
      });
    });
    const form = root.querySelector('.vitto-product__form');
    const submitButton = root.querySelector('.vitto-product__submit');
    const errorMessage = root.querySelector('[data-vitto-error]');
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const selectedVariantInput = root.querySelector('input[name="vitto-variant"]:checked');
      const selectedOfferInput = root.querySelector('input[name="vitto-offer"]:checked');
      if (!selectedVariantInput || !selectedOfferInput) return;
      submitButton.disabled = true;
      errorMessage.hidden = true;
      try {
        const baseRoute = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${baseRoute}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(selectedVariantInput.value), quantity: Number(selectedOfferInput.value) }]
          })
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(`${baseRoute}cart`);
      } catch (error) {
        errorMessage.textContent = root.dataset.cartError;
        errorMessage.hidden = false;
        submitButton.disabled = false;
      }
    });
    root.querySelector('[data-vitto-scroll]')?.addEventListener('click', () => {
      root.querySelector('.vitto-product__offers')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
